import { useQuery } from 'react-query'

import { stockImagesService } from 'src/services/stock-images.service'
import { IFilter } from 'src/components/filter/types/filter.types'
import { IStockImagesRespDto, IStockVideosRespDto } from 'src/types'
import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'

export const initialStockImagesFilterValues: IFilter = { query: '', limit: 20, page: 0 }

export const useStockImages = (filter: IFilter, switchValue: boolean) => {
  const queryKeys = switchValue ? QUERY_KEYS.STOCK_VIDEOS : QUERY_KEYS.STOCK_IMAGES

  return useQuery(
    [queryKeys, filter],
    async () => {
      if (switchValue) {
        const data = await stockImagesService.getStockVideos(
          removeDefaultParams(filter, initialStockImagesFilterValues),
        )
        return data as IStockVideosRespDto
      } else {
        const data = await stockImagesService.getStockImages(
          removeDefaultParams(filter, initialStockImagesFilterValues),
        )
        return data as IStockImagesRespDto
      }
    },
    {
      enabled: filter.query !== '',
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      keepPreviousData: true,
    },
  )
}
